// return the value from the func iff all of the args are defined (and not null)
//
// this helper can be used to prevent whole fields from being populated when there is not enough info entered
const whenDefined = (...args) => func => (args.every(el => el !== undefined && el !== null) ? func(...args) : undefined)

export default whenDefined



// WEBPACK FOOTER //
// ./src/utilities/Data/whenDefined.js